import { render, staticRenderFns } from "./file-component-vue.vue?vue&type=template&id=49f2e205&scoped=true&shadow"
import script from "./file-component-vue.vue?vue&type=script&lang=js&shadow"
export * from "./file-component-vue.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./file-component-vue.vue?vue&type=style&index=0&id=49f2e205&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "49f2e205",
  null
  ,true
)

export default component.exports